import * as Sentry from '@sentry/react';

export const checkForUserLeadHash = async ({
    hash,
    cookiesService,
    campaignId,
}) => {
    try {
        const cookieHash = cookiesService.getCookieByCampaign(campaignId)?.hash;
        const localStorageHash = localStorage.getItem('hash');

        return cookieHash || localStorageHash || hash || undefined;
    } catch (e) {
        Sentry.captureException(e);
    }
};
